import { AutogenModelEdipartnerXcompOrders, AutogenRowEdipartnerXcompOrders } from "./autogen/AutogenModelEdipartnerXcompOrders";

export class ModelEdipartnerXcompOrders extends AutogenModelEdipartnerXcompOrders<RowEdipartnerXcompOrders> {
	constructor() {
		super(RowEdipartnerXcompOrders);
	}
}

export class RowEdipartnerXcompOrders extends AutogenRowEdipartnerXcompOrders {
}